import React from 'react';
import { TextInput } from 'react-native-paper';
import { t, Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import { H1 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';
import { i18n } from '@src/i18n';

type Props = {
  search?: string;
  onChangeSearch?: (value: string) => void;
};

const Container = styled.View`
  justify-content: center;
  align-items: stretch;
  margin: 5px ${padding}px 15px ${padding}px;
`;

const SearchTitle = styled(H1)`
  margin: 10px ${padding}px;
`;

const Component: React.FC<Props> = ({ search, onChangeSearch }) => {
  return (
    <Container>
      <SearchTitle>
        <Trans>Search</Trans>
      </SearchTitle>
      <TextInput
        value={search}
        onChangeText={onChangeSearch}
        label={i18n._(t`Search Location`)}
      />
    </Container>
  );
};

export default Component;
